import * as angular from "angular";

const colorThemesList = ["#424242", "#0A6618", "#00847E", "#2C84AF",
  "#11349C", "#351093", "#760A80", "#C61B6C", "#950410", "#B35202"];

angular
  .module('bringoz.admin.site-preferences')
  .constant('sitePreferencesConstants', {
    colorThemesList: colorThemesList,
  });
